import { styled } from "@mui/joy";

export const IllustrationImg = styled("img")({});
